'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import Image from 'next/image'

// Icons
import { Icons } from '@/components/shared/icons'
import { ChevronDown } from 'lucide-react'

// Components
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '@/components/ui/hover-card'

// Config
import { siteConfig } from '@/config/site'

// Utils
import { cn } from '@/lib/utils'

export function MainNav() {
  const pathname = usePathname()

  return (
    <div className="hidden w-full items-center md:flex">
      <Link href="/" className="mr-4 flex items-center gap-2 lg:mr-0">
        <Icons.logo className="size-7 text-background" />
        <span className="hidden font-satoshi text-xl font-bold text-background lg:inline-block">
          {siteConfig.name}
        </span>
      </Link>
      <nav className="flex items-center justify-center gap-4 lg:flex-1 xl:gap-6 ">
        <HoverCard openDelay={1} closeDelay={200}>
          <HoverCardTrigger className="group cursor-pointer" asChild>
            <div
              className={cn(
                'flex items-center transition-colors hover:text-background',
                pathname.includes('/services') || pathname === '/services'
                  ? 'text-background'
                  : 'text-background/80'
              )}
            >
              <span>Services</span>
              <ChevronDown
                size={15}
                className="ml-1 transition-transform duration-300 ease-in-out group-hover:rotate-180"
              />
            </div>
          </HoverCardTrigger>
          <HoverCardContent
            className="ml-[80px] w-[650px] border-none bg-white lg:ml-[250px] mmd:ml-[200px] "
            sideOffset={20}
          >
            <div className="grid grid-cols-2 gap-3 ">
              <div>
                <Link
                  href="/twitch"
                  className="flex w-full rounded-lg px-4 py-2 transition duration-200 ease-in-out hover:bg-blue-100"
                >
                  <Image
                    src="/assets/icons/brand-icons/twitch.svg"
                    width={0}
                    height={0}
                    className="mr-6 mt-2 size-12"
                    sizes="100vw"
                    alt="Twitch logo"
                  />
                  <div className="">
                    <p className="text-start text-black">Twitch</p>
                    <p className=" mt-0.5 text-sm text-gray-600">
                      Understand how the {siteConfig.name} works on Twitch, and
                      discover how to leverage {siteConfig.name} for the best
                      possible outcomes on your Twitch channel.
                    </p>
                  </div>
                </Link>
              </div>
              <div>
                <Link
                  href="/kick"
                  className="flex w-full rounded-lg px-4 py-2 transition duration-200 ease-in-out hover:bg-blue-100"
                >
                  <Image
                    src="/assets/icons/brand-icons/kick.svg"
                    width={0}
                    height={0}
                    className="mr-6 size-16"
                    sizes="100vw"
                    alt="Kick logo"
                  />
                  <div className="">
                    <p className="text-start text-black">Kick</p>
                    <p className=" mt-0.5 text-sm text-gray-600">
                      Understand how the {siteConfig.name} works on Kick, and
                      discover how to leverage {siteConfig.name} for the best
                      possible outcomes on your Kick channel.
                    </p>
                  </div>
                </Link>
              </div>
            </div>
          </HoverCardContent>
        </HoverCard>
        <Link
          href="/pricing"
          className={cn(
            'transition-colors hover:text-background',
            pathname === '/pricing' ? 'text-background' : 'text-background/80'
          )}
        >
          Pricing
        </Link>
        <Link
          href="/blog"
          className={cn(
            'transition-colors hover:text-background',
            pathname?.startsWith('/blog')
              ? 'text-background'
              : 'text-background/80'
          )}
        >
          Blog
        </Link>
        <Link
          href="/contact"
          className={cn(
            'transition-colors hover:text-background',
            pathname === '/contact' ? 'text-background' : 'text-background/80'
          )}
        >
          Contact
        </Link>
        <Link
          href="/#faq"
          className={cn(
            'transition-colors hover:text-background',
            pathname === '/#faq' ? 'text-background' : 'text-background/80'
          )}
        >
          FAQ
        </Link>
      </nav>
    </div>
  )
}
